import * as React from "react";
import { WaitingOrderTransactions } from "../waiting-order-transactions";

// OrderTransactionType.Sell = 2
export const SellsWaitingForAcceptReceipt = () => (
    <WaitingOrderTransactions
        orderType={2}
        pageTitle="فروش های در انتظار تایید"
        cardTitle="فروش های در انتظار"
        className="pmx-sells-waiting-for-accept-receipt"
        exportFileName="فروش های در انتظار"
    />
);
